import { Table, Empty } from "antd";
import { t } from "i18next";
import PropTypes from "prop-types";

import MonitoringTableColumns from "./MonitoringTableColumns";
import "./scss/MonitoringTable.scss";

function MonitoringTable({ eventsData, eventTypes }) {
  const tableColumns = MonitoringTableColumns(eventTypes);
  const locale = {
    emptyText: (
      <Empty
        description={t("problems.no_data")}
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    ),
  };
  return (
    <div
      className="mt-4 ml-1 overflow-y-auto"
      style={{ height: "calc(100vh - 300px)" }}
    >
      <Table
        size="small"
        tableLayout="fixed"
        rowKey={(eventData) =>
          eventData?.EventId || eventData?.DeviceId || eventData?.DeviceUniqueId
        }
        dataSource={eventsData}
        columns={tableColumns}
        pagination={false}
        sticky
        scroll={{ x: "max-content" }}
        rowClassName={() => "monitoring-row"}
        locale={locale}
      />
    </div>
  );
}
MonitoringTable.propTypes = {
  eventsData: PropTypes.array,
  eventTypes: PropTypes.array,
};
MonitoringTable.defaultProps = {
  eventsData: [],
  eventTypes: [],
};
export default MonitoringTable;
